import styled from "styled-components";

export const FullWidth = styled.div`
  width: 100%;
`;
